import { render, staticRenderFns } from "./interestScheme.vue?vue&type=template&id=04ec457a&scoped=true&"
import script from "./interestScheme.vue?vue&type=script&lang=js&"
export * from "./interestScheme.vue?vue&type=script&lang=js&"
import style0 from "./interestScheme.vue?vue&type=style&index=0&id=04ec457a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec457a",
  null
  
)

export default component.exports